import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TeamListComponent } from 'src/app/private/modules/components/teams/team-list/team-list.component';
import { TeamService } from 'src/app/private/services/teams.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
@Component({
  selector: 'app-add-members',
  templateUrl: './add-members.component.html',
  styleUrls: ['./add-members.component.scss']
})
export class AddMembersComponent {
  btnLoading = false;
  initialLoad = true;
  @Input() teamId: any;
  selectedItems: any[] = [];
  @Input() users: any[] = [];
  @Input() selectedUsers: any[] = [];
  @Output() reloadData = new EventEmitter<void>();
  dropdownSettings: any = {

  };

  constructor(
    private localstorage: LocalStorageService,
    private api: TeamService,
    private toaster: ToastrService,
    private tracker: TrackingService,
  ) { }

  ngOnInit() {
    this.selectedItems = [];

    this.users = this.users.map((user: any) => {
      const isPreselected = this.selectedUsers.some(
        (selectedUser: any) => selectedUser.user_id === user.user_id
      );

      const formattedUser = {
        item_id: user.user_id,
        item_text: `${user.fname} ${user.lname}`,
        isDisabled: isPreselected
      };

      if (isPreselected) {
        // IMPORTANT: push the **same object** reference to selectedItems
        this.selectedItems.push(formattedUser);
      }

      return formattedUser;
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      allowSearchFilter: true,
      enableCheckAll: false,
      itemsShowLimit: 5,
      disableCheckbox: true
    };
  }




  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.close.emit();
  }




  addMember(isValid: any) {
    this.btnLoading = true;
    const userIds = this.selectedItems.map((item) => item.item_id);

    const paylaod = {
      "client_id": this.localstorage.getClientId(),
       user_id: userIds,
      "team_id": this.teamId
    }

    this.api.createTeamMember(paylaod).subscribe({
      next: (res) => {
        this.btnLoading = false;
        this.toaster.success("Team member added successfully");
        // ✅ Add tracking log here
      const desc = `Added team members length: ${userIds.length} to team ID: ${this.teamId}`;
      this.tracker.track("Bulk Add", "Team", desc)
        this.reloadData.emit();
        this.closeModal();
      }
      , error: (err) => {
        this.btnLoading = false;
        this.toaster.error(err.message || 'Something went wrong');
      }
    })
  }
}
